/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import {
  Grid,
  FormControl,
  TextField,
  Button,
  Select,
  MenuItem,
  Box,
  InputLabel,
  LinearProgress,
} from '@material-ui/core'
import '../Elegibilidad/Style/crearFormularioElegibilidad.scss'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useForm } from '../../../context/formContext'
import { useFormElegibilidad } from '../../../context/ElegibilidadContext'
import { useAuthentication } from '../../../context/authenticationContext'
import NumberFormat from 'react-number-format'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import ReactTooltip from 'react-tooltip'
import SelectReact from 'react-select'
import ManageSearchIcon from '@mui/icons-material/ManageSearch'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import Stack from '@mui/material/Stack'
import { useHistory } from 'react-router-dom'

import Modal from '@mui/material/Modal'
import swal from 'sweetalert'
import SaveIcon from '@material-ui/icons/Save'
import ExitIcon from '@material-ui/icons/ExitToApp'
import {
  getCurrency,
  getCurrencyByCountry,
  getIfiActionPlan,
  getMipymeByUser,
  getProjectByMiPYME,
  getProjectForm,
  getReportWithPlan,
  getReportWithoutPlan,
  insertDefaultValues,
} from '../../../services/Elegibilidad/get'

import { saveElegibilityForm } from '../../../services/Elegibilidad/create'
import Swal from 'sweetalert2'
import { useEligibility } from '../../../context/EligibilityContext'
import TableInformative from '../../../components/Table/TableInformative'
import { LoadingButton } from '@mui/lab'
import FileDownloadIcon from '@mui/icons-material/FileDownload'

const ElegibilidadSpec1 = (props) => {
  const { goToStep } = props
  const history = useHistory()
  const { pymeList, setCheckPYME } = useForm()
  const {
    EligibilityForm,
    setEligibilityForm,
    setIdElegibilityForm,
    setPreEligibilityForm2,
  } = useFormElegibilidad()
  const {
    // userName,
    userFullName,
    userIDB2C,
  } = useAuthentication()

  const [state, dispatch] = useEligibility()

  const [showExchange, setShowExchange] = useState(false)
  const [loadingExchange, setLoadingExchange] = useState(false)
  const [amountTest, setAmountTest] = useState('')
  const [options, setOptions] = useState([])
  const [selectedPYME, setSelectedPYME] = useState('')
  const [dataMIPYMESByUser, setDataMIPYMESByUser] = useState([])
  const [dataProject, setDataProject] = useState([])
  const [infoProject, setInfoProject] = useState([])
  const [currencyType, setCurrencyType] = useState([])
  const [currencyCode, setCurrencyCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [loadingSave, setLoadingSave] = useState(false)
  const [open, setOpen] = React.useState(false)
  const [openInformative, setOpenInformative] = useState(false)
  const [loadingPDF, setLoadingPDF] = useState(false)

  const getPDFWithoutPlan = async () => {
    setLoadingPDF(true)
    try {
      const response = await getReportWithoutPlan(0)
      if (response.Success) {
        setLoadingPDF(false)
        const byteCharacters = atob(response.Data.Report)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const filename = `Formulario  Elegibilidad`
        const blob = new Blob([byteArray], { type: 'application/pdf' })
        const link = document.createElement('a')

        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.click()
      }
    } catch (error) {
      console.log(error)
      setLoadingPDF(false)
    }
  }

  const handleOpen = () => setOpen(true)
  const handleClose = () => {
    setOpen(false)
    setSelectedPYME('')
    showExchange()
    amountTest()
  }

  const handleCloseInformative = () => {
    setOpenInformative(false)
  }

  const valueDate = {
    someDate: new Date().toISOString().substring(0, 10),
  }

  const min = '2021-06-30'
  const max = '2200-01-01'

  const GeneralDataSchema = Yup.object().shape({
    IdCurrencyUser: Yup.number().moreThan(0, 'Este campo es obligatorio'),
    TotalSubProjectBudget: Yup.number()
      .required('Este campo es obligatorio')
      // .when('IdCurrencyUser', (IdCurrencyUser, schema) => {
      //   if (Number(IdCurrencyUser) !== 0 && Number(IdCurrencyUser) === 3) {
      //     return schema.min(
      //       infoProject.RequiredAmount === 0 ? 1 : infoProject.RequiredAmount,
      //       'El monto debe ser mayor al monto total del préstamo solicitado.',
      //     )
      //   }
      // }),
      .when('IdCurrencyUser', {
        is: (IdCurrencyUser) =>
          Number(IdCurrencyUser) !== 0 && Number(IdCurrencyUser) === 3,
        then: Yup.number().test(
          'superior',
          'El monto no debe ser menor al monto total del préstamo solicitado.',
          function (f) {
            const ref = infoProject.RequiredAmount
            return f >= this.resolve(ref)
          },
        ),
      }),
    TotalSubProjectBudgetDollar: Yup.number()
      .required('Este campo es obligatorio')
      .when('IdCurrencyUser', {
        is: (IdCurrencyUser) =>
          Number(IdCurrencyUser) !== 0 && Number(IdCurrencyUser) !== 3,
        then: Yup.number().test(
          'superior',
          'El monto no debe ser menor al monto total del préstamo solicitado.',
          function (f) {
            const ref = infoProject.RequiredAmount
            return f >= this.resolve(ref)
          },
        ),
      }),
    PresentationDate: Yup.date().required(),
    ImplementationDateStart: Yup.date()
      .required('Este campo es obligatorio')
      .min(new Date(min), `La fecha de inicio no debe ser menor a ${min}`)
      .max(new Date(max), `La fecha de inicio no debe ser mayor al 2200`),
    ImplementationDateEnd: Yup.date()
      .required('Este campo es obligatorio')
      .max(new Date(max), `La fecha fin no debe ser mayor al 2200`)
      .when(
        'ImplementationDateStart',
        (ImplementationDateStart, schema) =>
          ImplementationDateStart &&
          schema.min(
            ImplementationDateStart,
            'La fecha de finalizacion no puede ser menor a la fecha de inicio.',
          ),
      )
      .when(
        'PresentationDate',
        (PresentationDate, schema) =>
          PresentationDate &&
          schema.min(
            PresentationDate,
            'La fecha de finalizacion no puede ser menor a la fecha de presentación.',
          ),
      ),
    IdIFI: Yup.string().required('Este campo es obligatorio'),
  })

  const formik = useFormik({
    validateOnChange: false,
    initialValues: {
      IdUserAzureB2C: userIDB2C,
      IdElegibilityAnswer: 0,
      IdMipyme: null,
      MiPymeName: '',
      IdRiskCategory: 'C',
      ImplementationDateStart: '',
      ImplementationDateEnd: '',
      PresentationDate: valueDate.someDate,
      IdCountryCredit: null,
      IdIFI: '',
      IdCurrencyUser: 0,
      TotalSubProjectBudget: 0,
      TotalSubProjectBudgetDollar: 0,
      IdProject: null,
      ProjectName: '',
      IdLegalRepresentative: null,
      LegalRepresentativeName: '',
      MiPymeCountry: '',
      RequiredAmount: 0,
      UserCurrencyToDollarExchangeRate: 1.0,
      idElegibilityForm: null,
      Draft: true,
      IdFormAction: 16,
      BusinessName: '',
      ENumber: '',
      RequiredAmountSourceCurrency: 0.0,
    },
    validationSchema: GeneralDataSchema,
    // Este submit es para guardar amigos... Necesario ojo....
    onSubmit: (values) => {
      saveForm(values, false)
    },
  })

  const saveForm = async (values, borrador, exit) => {
    setLoading(true)
    setLoadingSave(true)
    if (values.IdProject !== null && values.IdMipyme !== null) {
      try {
        let object = {
          ...values,
          ImplementationDateEnd:
            values.ImplementationDateEnd === ''
              ? null
              : values.ImplementationDateEnd,
          ImplementationDateStart:
            values.ImplementationDateStart === ''
              ? null
              : values.ImplementationDateStart,
          IdCurrencyUser:
            values.IdCurrencyUser === 0 ? null : values.IdCurrencyUser,
        }

        // Si el formulario ya fue creado
        if (object.IdElegibilityAnswer !== 0) {
          object = { ...object, IdFormAction: 17 }
        }

        const response = await saveElegibilityForm({
          ...EligibilityForm,
          ...object,
        })
        if (response.Code === 200) {
          setLoading(false)
          saveValuesToContext(values)
          setEligibilityForm((prev) => {
            return {
              ...prev,
              IdElegibilityAnswer: response.Data.IdElegibilityAnswer,
            }
          })
          setIdElegibilityForm(response.Data.IdElegibilityAnswer)
          formik.setFieldValue(
            'IdElegibilityAnswer',
            response.Data.IdElegibilityAnswer,
          )

          if (response.Data.IdElegibilityAnswer !== 0) {
            const responseDefault = await insertDefaultValues(
              response.Data.IdElegibilityAnswer,
            )
            // TODO: Revisar que pasa si el servicio falla
            if (responseDefault.Code !== 200) {
              // throw Error()
            }
          }

          if (borrador) {
            setLoadingSave(false)
            swal({
              title: 'Formulario Guardado',
              icon: 'success',
              button: 'Entendido',
            })
            if (exit) {
              history.push('/')
              setEligibilityForm([])
            }
          } else {
            setLoadingSave(false)
            next()
          }
        } else {
          throw Error(response.Message)
        }
      } catch (error) {
        setLoadingSave(false)
        console.log(error.message)
      }
    } else {
      setLoadingSave(false)
      alertValidationFields()
    }
  }

  const saveValuesToContext = (values) => {
    setEligibilityForm((previous) => {
      const valores = {
        Draft: values.Draft,
        IdElegibilityAnswer: values.IdElegibilityAnswer,
        IdMipyme: values.IdMipyme,
        MiPymeName: values.MiPymeName,
        IdRiskCategory: values.IdRiskCategory,
        ImplementationDateStart: values.ImplementationDateStart,
        ImplementationDateEnd: values.ImplementationDateEnd,
        PresentationDate: values.PresentationDate,
        IdCountryCredit: values.IdCountryCredit,
        IdIFI: values.IdIFI,
        IdCurrencyUser: values.IdCurrencyUser,
        TotalSubProjectBudget: values.TotalSubProjectBudget,
        TotalSubProjectBudgetDollar: values.TotalSubProjectBudgetDollar,
        IdProject: values.IdProject,
        ProjectName: values.ProjectName,
        IdLegalRepresentative: values.IdLegalRepresentative,
        LegalRepresentativeName: values.LegalRepresentativeName,
        MiPymeCountry: values.MiPymeCountry,
        RequiredAmount: values.RequiredAmount,
        UserCurrencyToDollarExchangeRate:
          values.UserCurrencyToDollarExchangeRate,
        idElegibilityForm: values.idElegibilityForm,
        IdFormAction: values.IdFormAction,
        Sector: values.Sector,
        MiPymeType: values.MiPymeType,
        TotalEmployees: values.TotalEmployees,
        IdUserAzureB2C: userIDB2C,
        ENumber: values.Enumber,
        RequiredAmountSourceCurrency: values.RequiredAmountSourceCurrency,
      }
      return {
        ...previous,
        ...valores,
      }
    })
  }

  const next = () => {
    dispatch({ type: 'SET_STATE', payload: 2 })
    goToStep(2)
  }

  const [pymeError, setPymeError] = useState('')

  const handlePYME = async () => {
    if (selectedPYME && selectedPYME.value !== 0) {
      setCheckPYME(true)
      setSelectedPYME('')
      setPymeError('')
      const data = dataMIPYMESByUser.filter(
        (e) => e.IdMiPyme === selectedPYME.value,
      )
      formik.setValues({
        ...formik.values,
        MiPymeName: data[0].MiPymeName,
        IdMipyme: data[0].IdMipyme,
      })

      const response = await getProjectByMiPYME(selectedPYME.value)

      setDataProject(response.Data)

      handleClose()
    } else {
      setPymeError('Campo Obligatorio')
      setSelectedPYME('')
    }
  }

  useEffect(() => {
    if (dataMIPYMESByUser && dataMIPYMESByUser.length > 0) {
      const array = []
      let struct
      for (let i = 0; i < dataMIPYMESByUser.length; i++) {
        struct = {
          value: dataMIPYMESByUser[i].IdMiPyme,
          label:
            ` ${dataMIPYMESByUser[i].TaxRegistration}` +
            ' - ' +
            `${dataMIPYMESByUser[i].MiPymeName}`,
        }

        array.push(struct)
      }
      if (array.length > 0) {
        setOptions(array)
      } else {
        setOptions([])
      }
    } else {
      setOptions([])
    }

    if (dataMIPYMESByUser && dataMIPYMESByUser.length === 1) {
      setCheckPYME(true)
      formik.setValues({
        ...formik.values,
      })
      setEligibilityForm({
        ...EligibilityForm,
        userFullName: userFullName,
      })
      // setEnablePYME(false)
    }
  }, [dataMIPYMESByUser])

  useEffect(() => {
    if (selectedPYME && selectedPYME.value !== '') {
      setPymeError('')
    }
  }, [selectedPYME])

  const SelectCurrencyUser = (e) => {
    switch (e.target.value) {
      case 1:
        setCurrencyCode('HNL')
        break
      case 2:
        setCurrencyCode('NIC')
        break
      case 3:
        setCurrencyCode('DOM')
        break
      case 4:
        setCurrencyCode('CRC')
        break
      case 5:
        setCurrencyCode('GTQ')
        break
      case 6:
        setCurrencyCode('DOP')
        break
    }
    if (e.target.value !== 3) {
      setShowExchange(true)
    } else {
      setShowExchange(false)
      formik.setFieldValue('TotalSubProjectBudgetDollar', 0)
    }

    formik.setValues({
      ...formik.values,
      IdCurrencyUser: e.target.value,
    })
  }

  // Funcion para el cambio de la moneda
  const handleCurrency = async (value) => {
    // setAmountTest(true)
    setLoadingSave(true)
    const dataCurrency = {
      SourceCurrencyCode: currencyCode,
      TargetCurrencyCode: 'USD',
      OriginalAmount: value,
    }

    const dataCurrency2 = {
      SourceCurrencyCode: 'USD',
      TargetCurrencyCode: currencyCode,
      OriginalAmount: 1,
    }

    const newValue = formik.values.TotalSubProjectBudget
    const newValueInt = newValue.toString().replaceAll(',', '')

    if (formik.values.IdCurrencyUser === 3) {
      setLoadingSave(false)
      await formik.setFieldValue(
        'TotalSubProjectBudgetDollar',
        Number(newValueInt),
      )
    } else {
      try {
        setLoadingExchange(true)
        const response = await getCurrency(dataCurrency)
        const response2 = await getCurrency(dataCurrency2)

        if (response2.error === null) {
          const Exchange =
            response2.result
              .retrieveGlobalStandardSpecificationCurrencyExchangeResponse
              .currencyExchange.resultingAmount

          formik.setFieldValue(
            'UserCurrencyToDollarExchangeRate',
            Number(Exchange),
          )
        }

        setLoadingExchange(false)
        formik.setFieldValue(
          'TotalSubProjectBudgetDollar',
          response.result
            .retrieveGlobalStandardSpecificationCurrencyExchangeResponse
            .currencyExchange.resultingAmount,
        )
        setLoadingSave(false)
      } catch (error) {
        console.log(error)
        swal({
          icon: 'error',
          title: 'Fallo en servicio',
          text: 'No se pudo convertir a USD!',
        })
      }
    }
  }

  const handleCurrencyLocal = async (value) => {
    const dataCurrency = {
      SourceCurrencyCode: 'USD',
      TargetCurrencyCode: currencyCode,
      OriginalAmount: value,
    }

    try {
      const response = await getCurrency(dataCurrency)
      formik.setFieldValue(
        'RequiredAmountSourceCurrency',
        response.result
          .retrieveGlobalStandardSpecificationCurrencyExchangeResponse
          .currencyExchange.resultingAmount,
      )
    } catch (error) {
      console.log(error)
      // swal({
      //   icon: 'error',
      //   title: 'Fallo en servicio',
      //   text: 'No se pudo convertir a USD!',
      // })
    }
  }

  useEffect(() => {
    if (
      currencyCode !== '' &&
      infoProject !== [] &&
      infoProject?.IdCurrency === 3 &&
      formik.values.IdCurrencyUser !== 3
    )
      if (infoProject?.IdCurrency === 3)
        handleCurrencyLocal(infoProject.RequiredAmount)
      else {
        formik.setFieldValue(
          'RequiredAmountSourceCurrency',
          infoProject.RequiredAmountSourceCurrency,
        )
      }
  }, [currencyCode, infoProject])

  const selectProject = async (e) => {
    const idProject = e.target.value
    try {
      const response = await getProjectForm(idProject)
      if (response.Success) {
        const [data] = response.Data
        formik.setValues(
          {
            ...formik.values,
            IdProject: idProject,
            MiPymeCountry: data.MiPymeCountry,
            IdCountryCredit: data.IdCountry,
            IdLegalRepresentative: data.IdLegalRepresentative,
            LegalRepresentativeName: data.LegalRepresentativeName,
            Sector: data.Sector,
            MiPymeType: data.MiPymeType,
            TotalEmployees: data.TotalEmployees,
            IdIFI: data.IdIFI,
            RequiredAmount: data.RequiredAmount,
            BusinessName: data.BusinessName,
            // ProjectName: e.target.name,
          },
          false,
        )
        setInfoProject(data)
        if (data.IdCurrency !== 3) {
          formik.setFieldValue(
            'RequiredAmountSourceCurrency',
            data.RequiredAmountSourceCurrency,
          )
        }
        setPreEligibilityForm2(data)

        await getListCurrencyByCountry(data.IdCountry)
      } else {
        throw Error(
          'Error obteniendo informacion de Proyecto: ' + response.Message,
        )
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  // Función para obtener la moneda por pais
  const getListCurrencyByCountry = async (InfoCountry) => {
    try {
      const response = await getCurrencyByCountry(InfoCountry)
      if (response.Success) {
        setCurrencyType(response.Data)
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  useEffect(() => {
    if (formik.values.IdCurrencyUser !== 0) {
      formik.setFieldValue('TotalSubProjectBudgetDollar', 0)
      handleCurrency(formik.values.TotalSubProjectBudget)
    }
  }, [formik.values.IdCurrencyUser, formik.values.TotalSubProjectBudget])

  const getMipymes = async () => {
    const response = await getMipymeByUser(userIDB2C)

    if (response.Success) {
      if (response.Data.length === 1) {
        setDataMIPYMESByUser(response.Data[0])
        formik.setFieldValue('MiPymeName', response.Data[0].MiPymeName, false)
        formik.setFieldValue('IdUserAzureB2C', userIDB2C, false)
        formik.setFieldValue('IdMipyme', response.Data[0].IdMipyme, false)

        const response2 = await getProjectByMiPYME(response.Data[0].IdMiPyme)
        setDataProject(response2.Data)
      } else {
        setDataMIPYMESByUser(response.Data)
        formik.setFieldValue('IdUserAzureB2C', userIDB2C)
      }
    }
  }
  useEffect(() => {
    getMipymes()
  }, [])

  const cancelForm = () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Se perderán los datos no guardados',
      icon: 'warning',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      confirmButtonColor: '#3085d6',
      denyButtonText: `No guardar`,
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        const exit = true
        saveForm(formik.values, true, exit)
      } else if (result.isDenied) {
        history.push('/')
        setEligibilityForm([])
      }
    })
  }

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  return (
    <>
      {' '}
      <Grid
        container
        md={12}
        sm={12}
        spacing={1}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Grid item>
          <div
            data-tip
            data-for="exitPop"
            onClick={() => cancelForm()}
            style={{
              backgroundColor: 'red',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <ExitIcon style={{ transform: 'scaleX(-1)' }} />
            <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
              <span>Regresar</span>
            </ReactTooltip>
          </div>
        </Grid>
        <Grid item>
          <div
            onClick={() => saveForm(formik.values, true)}
            style={{
              backgroundColor: '#5cb85c',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <SaveIcon data-tip data-for="savePop" data-tooltip-id="savePop" />
          </div>
          <ReactTooltip id="savePop" effect="solid" backgroundColor="#5cb85c">
            <span>Guardar Borrador </span>
          </ReactTooltip>
        </Grid>

        <Grid item>
          <div data-tip data-for="download" onClick={() => getPDFWithoutPlan()}>
            <LoadingButton
              loadingPosition="start"
              variant="contained"
              startIcon={
                <FileDownloadIcon style={{ transform: 'scaleX(-1)' }} />
              }
              style={{
                backgroundColor: '#5cb85c',
                color: '#fff',
                width: '40px',
                height: '34px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '4px',
                padding: '5px',
                cursor: 'pointer',
              }}
              loading={loadingPDF}
              // style={{ transform: 'scaleX(-1)' }}
            ></LoadingButton>
            <ReactTooltip
              id="download"
              effect="solid"
              backgroundColor="#5cb85c"
            >
              <span>Descargar</span>
            </ReactTooltip>
          </div>
        </Grid>
      </Grid>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <div className="pymeDiv">
            <h1 className="pymeTitle">Seleccione una MIPYME</h1>
            <p className="pymeDescription">
              Es necesario seleccionar una MIPYME para registrar un formulario
            </p>
          </div>
          {/** cambiar la condicion a > 1 */}
          {dataMIPYMESByUser.length > 1 ? (
            <Grid container spacing={1} className="input__container selectPYME">
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <SelectReact
                    classNamePrefix="select"
                    options={options}
                    placeholder="Seleccionar MIPYME"
                    onChange={(e) => setSelectedPYME(e)}
                    isClearable={true}
                    isSearchable={true}
                    defaultValue={selectedPYME}
                  />
                </FormControl>
                {pymeError !== '' ? (
                  <div
                    style={{ color: 'red', marginTop: '4px', fontSize: '13px' }}
                  >
                    {pymeError}
                  </div>
                ) : null}
              </Grid>
              <Grid className="buttonsPYME">
                <Button className="cancelButton" onClick={() => handleClose()}>
                  Cancelar
                </Button>
                <Button className="confirmButton" onClick={() => handlePYME()}>
                  Seleccionar
                </Button>
              </Grid>
            </Grid>
          ) : null}
        </Box>
      </Modal>
      {/* Modal informativo */}
      <Modal
        open={openInformative}
        onClose={handleCloseInformative}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <div className="pymeDiv">
            <h1 className="pymeTitle">Estado de las MIPYME</h1>
            <p className="pymeDescription">
              Evaluación de requisitos para la creación de formularios de
              Elegibilidad de las MIPYME manejadas por el usuario
            </p>
          </div>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TableInformative userIDB2C={userIDB2C} />
              </FormControl>
            </Grid>
            <Grid className="buttonsPYME">
              <Button
                className="cancelButton"
                onClick={() => handleCloseInformative()}
              >
                Salir
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <br></br>
      <form id="transfers-form" onSubmit={formik.handleSubmit}>
        <Grid item xs={12} sm={12} md={12}>
          <h1 className="h1text">INFORMACIÓN GENERAL</h1>
          <br />
        </Grid>

        <Grid container spacing={1}>
          <Grid container spacing={1} className="input__container">
            <Grid item xs={6} sm={6} md={6}>
              <label className="responsiveLabel">
                1.1. Nombre de la MIPYME
              </label>
              <a
                data-tip="- Seleccione la entidad MIPYME deseada para la creación <br/> del formulario (Siempre que haya más de una MIPYME creada con estado PRE-ELEGIBLE)"
                data-for="infoPymesPop"
                style={{ cursor: 'pointer' }}
              >
                <ErrorOutlineIcon fontSize="small" />
                <ReactTooltip
                  id="infoPymesPop"
                  effect="solid"
                  multiline={true}
                  type="dark"
                />
              </a>
              <a
                data-tip="-  Muestra la evaluación de los requisitos para <br/> la creación de formularios de Elegibilidad de las MIPYME manejadas por el usuario"
                data-for="infoPymesPop"
                style={{ cursor: 'pointer' }}
                onClick={() => setOpenInformative(true)}
              >
                <HelpOutlineIcon fontSize="small" />
                <ReactTooltip
                  id="infoPymesPop"
                  effect="solid"
                  multiline={true}
                  type="dark"
                />
              </a>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <label className="responsiveLabel">
                1.1.2. Seleccione el proyecto
              </label>
              <a
                data-tip="- Seleccione proyecto de MIPYME para la creación <br/> del formulario (Siempre que haya mas de un proyecto con estado PRE-ELEGIBLE)"
                data-for="infoPymesPop"
                style={{ cursor: 'pointer' }}
              >
                <ErrorOutlineIcon fontSize="small" />
                <ReactTooltip
                  id="infoPymesPop"
                  effect="solid"
                  multiline={true}
                  type="dark"
                />
              </a>
            </Grid>
            {dataMIPYMESByUser.length > 1 ? (
              <Grid item xs={6} sm={6} md={6}>
                <FormControl style={{ width: '100%' }}>
                  <div className="pymeSelect">
                    <TextField
                      id="MiPymeName"
                      name="MiPymeName"
                      style={{ width: '100%' }}
                      error={formik.errors.MiPymeName}
                      variant="outlined"
                      disabled
                      value={formik.values.MiPymeName || ''}
                    />
                    <a
                      data-tip="Seleccione una MIPYME para continuar con el registro de un formulario"
                      data-for="infoPYMEPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <Button
                        variant="outlined"
                        disabled={pymeList && pymeList.length === 1}
                        className={
                          pymeList && pymeList.length === 1
                            ? 'modalPYMESDisable'
                            : 'modalPYMES'
                        }
                        onClick={handleOpen}
                        data-tip="infoPYMEPop"
                      >
                        <ManageSearchIcon />
                      </Button>

                      <ReactTooltip
                        id="infoPYMEPop"
                        multiline={true}
                        type="dark"
                        disable={pymeList && pymeList.length === 1}
                      />
                    </a>
                  </div>

                  {formik.errors.MiPymeName ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.MiPymeName}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
            ) : (
              <Grid item xs={6} sm={6} md={6}>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="MiPymeName"
                    style={{ width: '100%' }}
                    error={formik.errors.MiPymeName}
                    variant="outlined"
                    disabled
                    value={formik.values.MiPymeName || ''}
                  />
                </FormControl>
              </Grid>
            )}

            {/** proyecto select */}
            <Grid item xs={6} sm={6} md={6}>
              <FormControl fullWidth>
                <InputLabel id="idProjectForm_">Seleccione una</InputLabel>
                <Select
                  id="IdProject"
                  name="IdProject"
                  error={formik.errors.IdProject}
                  labelId="idProjectForm_"
                  variant="outlined"
                  onChange={selectProject}
                  value={formik.values.IdProject || '0'}
                  displayEmpty={true}
                  renderValue={
                    formik.values.IdProject !== ''
                      ? undefined
                      : () => 'Seleccione una opción'
                  }
                >
                  <MenuItem disabled value="0">
                    Seleccione una opción
                  </MenuItem>
                  {dataProject &&
                    dataProject.map((item, key) => (
                      <MenuItem key={key} value={item.IdProject}>
                        {item.SubprojectName}
                      </MenuItem>
                    ))}
                </Select>
                {formik.errors.IdProject ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.IdProject}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                1.2. Período estimado de implementación de la inversión
              </label>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <Stack component="form" noValidate spacing={3}>
                  <TextField
                    id="ImplementationDateStart"
                    label="Desde"
                    type="date"
                    name="ImplementationDateStart"
                    variant="outlined"
                    sx={{ width: 220 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      min: '2021-06-30',
                    }}
                    error={formik.errors.ImplementationDateStart}
                    value={formik.values.ImplementationDateStart}
                    onChange={(e) => {
                      formik.handleChange(e)
                      if (e.target.value === '') {
                        formik.setValues({
                          ...formik.values,
                          ImplementationDateEnd: '',
                          ImplementationDateStart: '',
                        })
                      }
                    }}
                  />
                </Stack>
                {formik.errors.ImplementationDateStart ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.ImplementationDateStart}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <Stack component="form" noValidate spacing={3}>
                  <TextField
                    id="ImplementationDateEnd"
                    name="ImplementationDateEnd"
                    label="Hasta"
                    type="date"
                    variant="outlined"
                    error={formik.errors.ImplementationDateEnd}
                    sx={{ width: 220 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      min: formik.values.ImplementationDateStart,
                    }}
                    disabled={formik.values.ImplementationDateStart === ''}
                    onChange={formik.handleChange}
                    value={formik.values.ImplementationDateEnd || ''}
                  />
                </Stack>
                {formik.errors.ImplementationDateEnd ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.ImplementationDateEnd}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                1.3. Fecha de presentación del formato de formulación del
                subproyecto
              </label>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <Stack component="form" noValidate spacing={3}>
                  <TextField
                    id="PresentationDate"
                    name="PresentationDate"
                    type="date"
                    variant="outlined"
                    defaultValue={formik.values.PresentationDate}
                    sx={{ width: 220 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    className="multilineTextField"
                  />
                </Stack>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                1.4. País donde se solicitará el crédito
              </label>{' '}
              {/* <span style={{ color: 'red' }}>*</span> */}
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <Stack component="form" noValidate spacing={3}>
                  <TextField
                    id="MiPymeCountry"
                    name="MiPymeCountry"
                    type="text"
                    variant="outlined"
                    value={formik.values.MiPymeCountry || ''}
                    sx={{ width: 220 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    className="multilineTextField"
                  />
                </Stack>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                1.5. Institución Financiera
              </label>{' '}
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth disabled>
                <Stack component="form" noValidate spacing={3}>
                  <TextField
                    id="MiPymeCountry"
                    name="MiPymeCountry"
                    type="text"
                    variant="outlined"
                    value={formik.values.BusinessName || ''}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    className="multilineTextField"
                  />
                </Stack>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                1.6. Presupuesto total del proyecto{' '}
                <span style={{ color: 'red' }}>*</span>
                <a
                  data-tip="Ingrese la moneda de préstamo"
                  data-for="infoCurrencyPop"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoCurrencyPop"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </label>
            </Grid>

            <Grid item xs={4} sm={4} md={4}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Moneda</label>
              </Grid>
              <FormControl fullWidth>
                <Select
                  id="IdCurrencyUser"
                  name="IdCurrencyUser"
                  value={formik.values.IdCurrencyUser || ''}
                  displayEmpty={true}
                  error={formik.errors.IdCurrencyUser}
                  renderValue={
                    formik.values.IdCurrencyUser !== 0
                      ? undefined
                      : () => 'Seleccione una opción'
                  }
                  onChange={SelectCurrencyUser}
                  // onBlur={SelectCurrencyUser}
                  variant="outlined"
                >
                  <MenuItem value={''} disabled>
                    Seleccione una opción
                  </MenuItem>
                  {currencyType &&
                    currencyType.map((item) => (
                      <MenuItem key={item.IdCurrency} value={item.IdCurrency}>
                        {item.Description}
                      </MenuItem>
                    ))}
                </Select>
                {formik.errors.IdCurrencyUser ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.IdCurrencyUser}
                  </div>
                ) : null}
              </FormControl>
            </Grid>

            <Grid item xs={4} sm={4} md={4}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Monto</label>
              </Grid>
              <FormControl style={{ width: '100%' }}>
                <NumberFormat
                  id="TotalSubProjectBudget"
                  name="TotalSubProjectBudget"
                  customInput={TextField}
                  thousandSeparator={true}
                  value={formik.values.TotalSubProjectBudget}
                  decimalScale={2}
                  disabled={formik.values.IdCurrencyUser === 0}
                  onBlur={(e) => {
                    const valueUnformatted = Number(
                      e.target.value.replaceAll(',', ''),
                    )
                    formik.setFieldValue(
                      'TotalSubProjectBudget',
                      Number(valueUnformatted),
                    )
                  }}
                  autoComplete="off"
                  allowNegative={false}
                  error={formik.errors.TotalSubProjectBudget}
                  variant="outlined"
                  inputProps={{ maxLength: 18 }}
                  allowLeadingZeros={false}
                  fixedDecimalScale
                />
                {formik.errors.TotalSubProjectBudget ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.TotalSubProjectBudget}
                  </div>
                ) : null}
              </FormControl>
            </Grid>

            {showExchange ? (
              <Grid item xs={4} sm={4} md={4}>
                {loadingExchange ? (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    style={{ marginTop: '8%' }}
                  >
                    <LinearProgress />
                  </Grid>
                ) : (
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        Monto moneda USD
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl style={{ width: '100%' }}>
                        <NumberFormat
                          id="TotalSubProjectBudgetDollar"
                          name="TotalSubProjectBudgetDollar"
                          customInput={TextField}
                          thousandSeparator={true}
                          value={formik.values.TotalSubProjectBudgetDollar}
                          autoComplete="off"
                          disabled
                          prefix="$"
                          allowNegative={false}
                          allowLeadingZeros={false}
                          error={formik.errors.TotalSubProjectBudgetDollar}
                          variant="outlined"
                          // onBlur={() => getExchange()}
                          isNumericString={true}
                          inputProps={{ maxLength: 18 }}
                          className="multilineTextField"
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            ) : (
              ''
            )}
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={4} sm={4} md={4}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  1.7. Monto del préstamo solicitado USD
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <NumberFormat
                    id="RequiredAmount"
                    name="RequiredAmount"
                    customInput={TextField}
                    thousandSeparator={true}
                    value={infoProject.RequiredAmount}
                    autoComplete="off"
                    disabled
                    prefix="$"
                    allowNegative={false}
                    error={formik.errors.RequiredAmount}
                    variant="outlined"
                    isNumericString={true}
                    inputProps={{ maxLength: 12 }}
                    fixedDecimalScale
                    decimalScale={2}
                    className="multilineTextField"
                  />
                </FormControl>
              </Grid>
            </Grid>
            {formik.values.IdCurrencyUser !== 3 &&
              formik.values.IdCurrencyUser !== 0 && (
                <Grid
                  item
                  xs={4}
                  sm={4}
                  md={4}
                  justifyContent="flex-end"
                  style={{ alignItems: 'flex-end', justifyContent: 'flex-end' }}
                >
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      Monto moneda local
                    </label>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    justifyContent="flex-end"
                    style={{
                      alignItems: 'flex-end',
                      justifyContent: 'flex-end',
                      position: 'relative',
                    }}
                  >
                    <FormControl style={{ width: '100%' }}>
                      <NumberFormat
                        id="TotalSubProjectBudgetDollar"
                        name="TotalSubProjectBudgetDollar"
                        customInput={TextField}
                        thousandSeparator={true}
                        value={formik.values.RequiredAmountSourceCurrency}
                        autoComplete="off"
                        disabled
                        allowNegative={false}
                        variant="outlined"
                        isNumericString={true}
                        inputProps={{ maxLength: 12 }}
                        className="multilineTextField"
                        fixedDecimalScale
                        decimalScale={2}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              )}
          </Grid>

          <Grid container spacing={1} className="general_button">
            <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'right' }}>
              <LoadingButton
                loading={loadingSave}
                type="button"
                onClick={() => validateFormStatus()}
                className="button__wizard button__next"
                variant="outlined"
              >
                Siguiente
              </LoadingButton>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default ElegibilidadSpec1
